import { ParallaxSection } from '@web/components/ParallaxSection'
import { SubHero } from '@web/components/SubHero'
import Hero from '../sections/Hero/Hero'
import FeaturesSection from '@web/sections/Home/FeaturesSection'
import IntroSection from '@web/sections/Home/IntroSection'
import QuoteSection from '@web/sections/Home/QuoteSection'
import ChallengesSection from '@web/sections/Home/ChallengesSection'
import { useState } from 'react'
import { SolutionsModal } from '@web/sections/Home/SolutionsModal'
import ClientsSection from '@web/sections/Home/ClientsSection'
import { DemoButton } from '@web/components/DemoButton'
import FooterSection from '@web/sections/Home/FooterSection'
import LinkedInComponent from '@web/components/LinkedInComponent'

export function HomePage() {
  const [solutionsModalOpen, setSolutionsModalOpen] = useState(false)

  // Handler to open modal with custom content
  const handleOpenSolutionsModal = () => {
    setSolutionsModalOpen(true)
  }
  return (
    <>
      <Hero />
      <SubHero />
      <>
        <FeaturesSection />
        <IntroSection />
        <QuoteSection
          quote="Resilience Explorer® Proving to be a game changer, the platform ascribes a level of vulnerability to assets – so it operates as a risk screening tool to allow us to understand the risk profile of a district, the areas where risk is most imminent, and importantly, which assets are most vulnerable to which hazards, and over which time periods."
          name="Jane Morgan"
          title="Principal Programme Advisor Christchurch City Council"
        />
        <ParallaxSection image="/website/meeting_candid.png" overlayOpacity="bg-black/30">
          <div className="z-10 flex items-center justify-center w-full h-full px-6 py-8 text-white md:pt-24">
            <div className="flex flex-col items-center justify-center h-full gap-8 max-w-7xl max-h-40 md:max-h-80 md:gap-16">
              <h1 className="text-[clamp(20px,4vw,44px)] text-pretty text-center leading-tight font-extralight">
                The NPS-NH is already in force, LIM Regulations now require standardised hazard
                data, and Regional Spatial Plans are on the horizon.
              </h1>
              <h1 className="text-[clamp(20px,4vw,44px)] text-pretty text-center leading-tight font-medium">
                Resilience Explorer® helps you meet all three.
              </h1>
              <button
                className="hidden px-24 py-3 text-sm font-semibold text-white no-underline transition-colors border-0 rounded cursor-pointer bg-brand-blue hover:bg-brand-navy md:block"
                onClick={handleOpenSolutionsModal}
              >
                See how
              </button>
            </div>
          </div>
        </ParallaxSection>
        <button className="block w-full px-8 py-3 text-sm font-semibold text-white no-underline transition-colors border-0 shadow-lg cursor-pointer bg-brand-blue hover:bg-brand-navy md:hidden">
          See how
        </button>
        <ChallengesSection onModalOpen={handleOpenSolutionsModal} />
        <ParallaxSection image="/website/urban_connections.jpg" overlayOpacity="bg-black/30">
          <div className="z-10 flex items-center justify-center w-full h-full px-6 py-8 text-white md:pt-24">
            <div className="flex flex-col items-center justify-center h-full gap-8 max-w-7xl max-h-40 md:max-h-80 md:gap-16">
              <h1 className="text-[clamp(20px,4vw,44px)] text-pretty text-center leading-tight font-extralight">
                Resilience Explorer® models how consequences propagate across interdependent
                infrastructure networks. When a flood damages a substation, we show the power
                outage, the water treatment failure, the road isolation, and the community impact.
              </h1>
              <h1 className="text-[clamp(20px,4vw,44px)] text-pretty text-center leading-tight font-medium">
                No other platform does this.
              </h1>
              <button
                className="hidden px-8 py-3 text-sm font-semibold text-white no-underline transition-colors border-0 rounded cursor-pointer bg-brand-blue hover:bg-brand-navy sm:block"
                onClick={handleOpenSolutionsModal}
              >
                Resilience Explorer® in Action
              </button>
            </div>
          </div>
        </ParallaxSection>
        <button
          className="block w-full px-8 py-3 text-sm font-semibold text-white no-underline transition-colors border-0 shadow-lg cursor-pointer bg-brand-blue hover:bg-brand-navy sm:hidden"
          onClick={handleOpenSolutionsModal}
        >
          Resilience Explorer® in Action
        </button>
        <ClientsSection />
        <ParallaxSection image="/website/stairwell_conversation.jpg" overlayOpacity="bg-black/30">
          <div className="z-10 flex items-end justify-center w-full h-full px-6 py-16 text-white">
            <div className="flex flex-col items-center justify-end h-full gap-8 max-w-7xl max-h-40 md:max-h-80 md:gap-16">
              <h1 className="text-[clamp(20px,4vw,44px)] text-pretty text-center leading-tight font-extralight">
                <span className="font-medium">Not sure where to start?</span>
                <br />
                Our team can assess your readiness and get you set up
              </h1>
              <DemoButton />
            </div>
          </div>
        </ParallaxSection>
        <LinkedInComponent />
        <FooterSection />
        <SolutionsModal modalOpen={solutionsModalOpen} setModalOpen={setSolutionsModalOpen} />
      </>
    </>
  )
}
